/** @format */

import React, { useState } from 'react';
import {
  Grid,
  IconButton,
  Button,
  Typography,
  CardActions,
  Card,
  CardContent,
} from '@mui/material';
import { ButtonLoading, Icons, TableItemActionsNew, SimpleDialog, PriceLabel } from 'components';
import { useNavigate } from 'react-router-dom';
import SubsetServices from '../../../Subsets/services/SubsetServices';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { useCurrencyUnit } from 'hooks';

export default function ImprestItemReport({ data, actionsList, refreshList }) {
  // --STATES--//

  // --HOOKS--//
  const classes = useStyles();
  const navigate = useNavigate();
  const [dialog, setDialog] = useState({});
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [loadingBtnAccept, setLoadingBtnAccept] = useState(false);
  const [loadingBtnIgnore, setLoadingBtnIgnore] = useState(false);
  const currencyText = useCurrencyUnit();
  // -- LOCAL VARIABLES --//
  const ChangeStateActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtn}
          name="بله"
          onClick={dialog?.onAccept}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };
  const changeStateOfBranch = async (selectedRow, changeStatusGroup) => {
    setLoadingBtn(true);

    if (changeStatusGroup) setLoadingBtnAccept(true);
    else setLoadingBtnIgnore(true);

    try {
      if (Array.isArray(selectedRow)) {
        const filterBaseOnSameState = selectedRow.filter(
          (row) => row.isActive !== changeStatusGroup,
        );

        if (filterBaseOnSameState.length) {
          await SubsetServices.changeStateOfBranch({
            branchId: filterBaseOnSameState.map((row) => row.id),
            enable: changeStatusGroup,
          });
        }
      } else {
        await SubsetServices.changeStateOfBranch({
          branchId: selectedRow.map((branch) => branch.id),
          enable: !selectedRow.isActive,
        });
      }
      setTimeout(() => {
        refreshList();
      }, 100);
    } catch (error) {
    } finally {
      setLoadingBtn(false);
      setLoadingBtnAccept(false);
      setLoadingBtnIgnore(false);
      handleCloseDialog();
    }
  };
  const formatFourDigits = (str) => {
    return str.replace(/(.{4})/g, '$1-').replace(/-$/, '');
  };
  const handleCloseDialog = () => {
    setDialog({ title: '', content: '', open: false, onAccept: () => null });
  };
  const handleTransfer = () => {
    const queryParams = new URLSearchParams({
      username: data.username,
      fullName: data.name,
      userId: data.userId,
      userInfoType: 'username',
      userInfo: data.username,
      transferType: 'wallet',
      directFrom: 'imprest',
    });

    navigate(`/TransferToImprest?${queryParams.toString()}`);
  };

  const handleIssueCard = () => {
    const queryParams = new URLSearchParams({
      name: data.name,
      fullNameOwner: data.name,
      id: data.id,
      Type: 'Imprest',
    });

    navigate(`/IssueCards?${queryParams.toString()}`, {
      state: data,
    });
  };

  const handleViewTransactions = () => {
    const queryParams = new URLSearchParams({
      imprest: 'true',
    });

    navigate(`/Branch/Transactions/${data.id}?${queryParams.toString()}`, {
      state: data,
    });
  };

  const ChangeStateGroupActionBtn = () => {
    return (
      <>
        <ButtonLoading
          type="submit"
          variant="contained"
          color="primary"
          loading={loadingBtnAccept}
          name="فعال‌سازی"
          onClick={() => changeStateOfBranch(dialog.data, true)}
        />

        <ButtonLoading
          type="submit"
          variant="outlined"
          color="primary"
          loading={loadingBtnIgnore}
          name="غیرفعال‌سازی"
          className={classes.disabledRow}
          onClick={() => changeStateOfBranch(dialog.data, false)}
        />

        <Button variant="contained" onClick={handleCloseDialog}>
          انصراف
        </Button>
      </>
    );
  };

  return (
    <>
      <Card xs={12} className={clsx(classes.root, {})}>
        <CardContent className={clsx(classes.content, {})}>
          {/* Titles */}
          <Grid
            container
            justifyContent="space-between"
            alignItems="flex-start"
            className={classes.cardHeader}
          >
            <Grid item className={classes.titlePart}>
              <Typography variant="h5" className={classes.titleText}>
                {data?.name}
              </Typography>
            </Grid>
            {actionsList['imprestListUpdateAction'] && (
              <Grid item className={classes.titleActions}>
                <IconButton
                  className={classes.actionsIcon}
                  onClick={() => navigate(`/Imprest/${data.id}`)}
                  size="large">
                  <Icons icon="Edit" color="#000" size="23" />
                </IconButton>
              </Grid>
            )}
          </Grid>

          <div className={classes.cardInside}>
            {/* Balances */}
            <Grid container justifyContent="space-between">
              <Grid item xs={6}>
                <Typography className={classes.balanceTitle}>شناسه تنخواه </Typography>
                <Typography className={classes.balanceMoney}>
                  <span>{data?.id || '-'}</span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.balanceTitle}>مالک تنخواه </Typography>
                <Typography className={classes.balanceMoney}>
                  <span>
                    {data?.ownerName && data?.ownerName?.trim?.()?.length !== 0
                      ? data?.ownerName
                      : '-'}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.balanceTitle}>شماره کارت </Typography>
                <Typography className={classes.balanceMoney}>
                  <span>
                    {data?.cardNumber && data?.cardNumber
                      ? formatFourDigits(data?.cardNumber)
                      : '-'}
                  </span>
                </Typography>
              </Grid>
              <Grid item xs={6}>
                {data?.totalAmount && (
                  <>
                    <Typography className={classes.balanceTitle}> موجودی </Typography>
                    <Typography className={classes.balanceMoney}>
                      <span>
                        {data?.totalAmount && data?.totalAmount !== '0'
                          ? <PriceLabel amount={data?.totalAmount} />
                          : data?.totalAmount || '0'}
                      </span>
                      <span> {currencyText}</span>
                    </Typography>
                  </>
                )}
              </Grid>
            </Grid>
          </div>
        </CardContent>
        <CardActions className={classes.actionButtons}>
          <Grid container className={classes.actionButtonsBlock}>
            {actionsList['imprestListChargeBtn'] && (
              <ButtonLoading
                onClick={handleTransfer}
                size="small"
                className={classes.actionButton}
                name="شارژ تنخواه"
              />
            )}
            {actionsList['imprestCardService'] && (
              <Button
                onClick={handleIssueCard}
                size="small"
                className={classes.actionButton}
              // disabled={!data?.cardNumber}
              >
                خدمات کارت
              </Button>
            )}
            {actionsList['imprestListReportBtn'] && (
              <Button
                onClick={handleViewTransactions}
                size="small"
                className={classes.actionButton}
              >
                گزارش صورتحساب
              </Button>
            )}

            {/* Other Actions */}
            {(actionsList['imprestListDelegationAction'] ||
              actionsList['imprestListZeroOutAction'] ||
              actionsList['imprestListFinancialLimitAction'] ||
              actionsList['imprestListOtherBalanceAction'] ||
              actionsList['imprestListUpdateActivationAction'] ||
              actionsList['imprestListDetailAction']) && (
                <div className={classes.otherActions}>
                  <TableItemActionsNew
                    iconButton
                    startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
                    title=""
                    otherMenus={[
                      {
                        title: 'عملیات مالی',
                        isShow: !!(
                          actionsList['imprestListDelegationAction'] ||
                          actionsList['imprestListZeroOutAction'] ||
                          actionsList['imprestListFinancialLimitAction']
                        ),
                        isOpen: false,
                        id: 'FinancialOperation',
                        children: [
                          {
                            title: 'عودت وجه',
                            isShow: !!actionsList['imprestListTransferAction'],
                            onClick: () => navigate(`/WithdrawToParent/${data.id}`, { state: data }),
                          },
                          {
                            title: 'تفویض وجه',
                            isShow: !!actionsList['imprestListDelegationAction'],
                            onClick: () =>
                              navigate(`/DelegationToUser?username=${data.username}&Type=Imprest`, {
                                state: data,
                              }),
                          },
                          {
                            title: 'سقف مالی شعبه',
                            isShow: !!actionsList['imprestListFinancialLimitAction'],
                            onClick: () =>
                              navigate(`/Branch/${data.id}/financial?imprest=true`, { state: data }),
                          },
                        ],
                      },
                      {
                        title: 'عملیات تنخواه گردانی',
                        isShow: !!actionsList['imprestListUpdateActivationAction'],
                        isOpen: false,
                        id: 'operatin',
                        children: [
                          {
                            title: data?.isActive
                              ? 'غیرفعال‌ سازی تنخواه گردان '
                              : 'فعال‌ سازی تنخواه گردان',
                            onClick: () => {
                              setDialog({
                                title: data?.isActive
                                  ? ` غیرفعال‌ سازی تنخواه گردان ${data.name}`
                                  : ` فعال‌ سازی تنخواه گردان ${data.name} `,
                                content: data?.isActive
                                  ? 'با انجام این عملیات، شعبه/تنخواه گردان مورد نظر دیگر امکان برداشت وجه از حساب خود در پنل کسب و کار را نخواهد داشت. آیا از این تغییر مطمئن هستید؟'
                                  : 'آیا از انجام این عملیات اطمینان دارید؟',
                                open: true,
                                data: data,
                                type: 'ChangeStateActionBtn',
                                onAccept: () => {
                                  changeStateOfBranch([data], !data?.isActive);
                                },
                              });
                            },
                          },
                        ],
                      },

                      {
                        title: 'گزارشات',
                        isShow: !!actionsList['imprestListDetailAction'],
                        isOpen: false,
                        id: 'reports',
                        children: [
                          {
                            title: 'موجودی تنخواه',
                            isShow: true,
                            onClick: () => {
                              navigate(`/Imprest/ReceiveInventory/${data.id}`, { state: data });
                            },
                          },
                          {
                            title: 'گزارش تجمیعی تنخواه',
                            isShow: true,
                            onClick: () => {
                              navigate(`/Imprest/ReportSummary/${data.id}?ImprestName=${data.name}`, {
                                state: data,
                              });
                            },
                          },
                          {
                            title: 'گزارش واریزی‌ها',
                            isShow: true,
                            onClick: () =>
                              navigate(`/Imprest/DepositReport/${data.id}?ImprestName=${data.name}`, {
                                state: data,
                              }),
                          },
                          {
                            title: 'جزئيات',
                            isShow: true,
                            onClick: () =>
                              navigate(`/Branch/${data.id}/detail?Imprest=true`, { state: data }),
                          }

                        ],
                      },
                    ]}
                  />
                </div>
              )}
          </Grid>
        </CardActions>
      </Card>
      {dialog.type === 'ChangeStateActionBtn' && (
        <SimpleDialog
          title={dialog?.title}
          content={dialog?.content}
          open={dialog?.open || false}
          actions={<ChangeStateActionBtn />}
        />
      )}

      {dialog.type === 'ChangeStateGroupActionBtn' && (
        <SimpleDialog
          title={dialog?.title}
          content={dialog?.content}
          open={dialog?.open || false}
          actions={<ChangeStateGroupActionBtn />}
        />
      )}
    </>
  );
}

const darkGray = '#263238';
const lightGray = '#3f505a';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      boxShadow: 'none',
      border: '1px solid #A1AAE380',
      borderRadius: 10,
      background: '#A1AAE312',
      minHeight: '95px !important',
      padding: theme.spacing(0),
      paddingBottom: theme.spacing(0.5),
      boxSizing: 'border-box',
      margin: 0,
      '& .MuiAccordionSummary-content': {
        margin: 0,
        padding: 0,
      },
      '& .MuiCardContent-root': {
        padding: 0,
      },
      '&.disabled': {
        opacity: 0.5,
      },
    },
    content: {
      position: 'relative',
    },
    titlePart: {
      marginInlineEnd: 'auto',

      '@media(max-width: 550px)': {
        width: '80%',
      },
    },
    titleText: {
      fontSize: 16,
      color: darkGray,
      fontWeight: 'bold',
    },
    actionButtons: {
      marginTop: theme.spacing(0),
      marginInlineStart: theme.spacing(0.6),
      '& .MuiGrid-container': {
        '@media(max-width: 550px)': {
          gap: ' 8px',
        },
      },
    },
    actionButtonsBlock: {
      gap: '6px',
    },
    actionButton: {
      color: theme.palette.primary.main,
      paddingInlineStart: 10,
      paddingInlineEnd: 10,
      borderRadius: 8,
      boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.07)',
      border: 'solid 1px #e7e7f1',
      fontSize: '12px',
      backgroundColor: '#ffffff',
      '@media(max-width: 550px)': {
        fontSize: 12,
        width: '48%',
        margin: '0',
        '&:nth-child(3)': {
          width: '99%',
        },
      },
    },
    balanceTitle: {
      fontSize: 14,
      color: '#A4A4A4',
      fontWeight: 'normal',
    },
    balanceMoney: {
      marginBottom: theme.spacing(2),
      fontSize: 14,
      color: '#2A2A2A',
      fontWeight: 'bold',
      '& span': {
        fontSize: 14,
        color: lightGray,
        '@media(max-width: 1450px)': {
          fontSize: 12,
        },
        '@media(max-width: 1250px)': {
          fontSize: 14,
        },
      },
    },
    titleActions: {
      marginInlineEnd: theme.spacing(0),
      marginTop: theme.spacing(0),
    },
    actionsIcon: {
      marginInlineStart: theme.spacing(0.5),
      padding: 0,
      '& svg': {
        '& path': {
          stroke: '#303d8f',
        },
      },
    },
    otherActions: {
      marginInlineStart: 'auto',
      marginInlineEnd: theme.spacing(0.7),
      paddingTop: '5px',
      lineHeight: '34px',
      '@media(max-width: 550px)': {
        fontSize: 12,
        width: '100%',
        margin: '0',
        lineHeight: '40px',
        textAlign: 'right',
        paddingRight: '6px',
        '& .otherActions': {
          width: '33px',
        },
      },

      '& .MuiIconButton-root': {
        border: '2px solid #303d8f',
        borderRadius: '50%',
        width: '25px',
        height: '25px',
        padding: '0',
        marginRight: 3,
        '& svg': {
          fill: '#303d8f',
          transform: 'scale(0.8)',
        },
      },
      '& .MuiButton-text': {
        fontSize: 13,
        color: '#3a49a3',
        fontWeight: 'bold',
      },
    },
    cardHeader: {
      padding: theme.spacing(2),
    },
    cardInside: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  };
});
